import { SKIP_BASIC_AUTH_HEADER } from '../../API/constants';

function UserPresence(core) {
    this.client = core.client;
}

const baseUrl = `../api/v1/User/${config.pbxExtension}/Presence?${SKIP_BASIC_AUTH_HEADER}`;

Object.assign(UserPresence.prototype, {
    namespace: 'UserPresence',
    get(params) {
        return this.client.send('GET', baseUrl, params);
    }
});

export default UserPresence;
